import {computed} from 'vue'
import auth from 'shared/plugins/auth'
import {useStore} from 'shared/stores/store'
import {useWorkspaceSubscriptionStore} from 'shared/stores/workspaceSubscription'

export const useUserCategory = () => {
	const store = useStore()
	const workspaceSubscription = useWorkspaceSubscriptionStore()

	const userCategory = computed(() => {
		if (!auth?.isAuthenticated.value) return '[Not yet authenticated]'
		if (!store.user) return '[User not yet loaded]'
		if (store.isBrowserstackUser == false) return 'BEB Users'
		if (!store.workspace?.id) return '[Workspace not yet loaded]'
		if (!store.workspace.browserstackId) return 'BEB Users'
		if (workspaceSubscription.isTrialPlan) return 'Free Trial'
		if (store.user.browserstackProductAccess) return 'Early access'
		if (workspaceSubscription.plan?.id === 'browserstack-free-plus') return 'Waitlist'
		return 'Others'
	})

	return {userCategory}
}
